import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { OfflineError } from '../offline-check.interceptor';

export const pingBaseUrl = `${environment.portalApiUrl}/public/ping`;

@Injectable({ providedIn: 'root' })
export class PingApiService {
  constructor(private readonly http: HttpClient) {}

  pingApiStatus() {
    return this.http.get<null>(pingBaseUrl).pipe(
      map(() => true),
      catchError((error: OfflineError) => {
        return of(error);
      }),
    );
  }
}
